import { ref, computed } from 'vue'
import { useLogError } from '@/composables/useLogError'
import { useAuthStore } from '@/stores/useAuthStore'
import { useCubeStore } from '@/stores/useCubeStore'
import { useHttpClient } from '@/composables/useHttpClient'

export function useDownloads() {
  const { logError } = useLogError()
  const { backendApi } = useHttpClient()

  const downloads = ref([])

  const downloadAllLink = computed(() => {
    const authStore = useAuthStore()
    const cubeStore = useCubeStore()
    return (
      authStore.urls.backend +
      `/app/getAllMeterData?cubeName=${cubeStore.name}&dataFormat=xlsx&efToken=${authStore.backendAccessToken}`
    )
  })

  async function load() {
    const cubeStore = useCubeStore()
    const authStore = useAuthStore()
    const withToken = (href) => `${authStore.urls.backend}${href}&efToken=${authStore.backendAccessToken}`
    try {
      //ToDo: refactor backend response to look normal
      const data = (await backendApi.get('/app/getDownloadList', {
        params: { cubeName: cubeStore.name },
      })).data.data.data

      downloads.value = Object.values(data).flatMap((year) =>
        Object.values(year).map((entry) => ({
          caption: entry.caption,
          dailyUrl: withToken(entry.linkDaily.href),
          dailyCaption: entry.linkDaily.caption,
          fifteenMinUrl: withToken(entry.link15Min.href),
          fifteenMinCaption: entry.link15Min.caption,
        }))
      )
    } catch (err) {
      logError(`Requesting downloadables list failed: ${err}`)
    }
  }

  return {
    downloads,
    downloadAllLink,
    load,
  }
}
